<template>
    <div id="longTimeGame">
      <headerPage :title="title" :iconSrc='iconSrc' :headerSty='headerSty'></headerPage>
      <headerBg :headerBg="headerBg" class="headerBg"></headerBg>
          <gameImg :game='game'></gameImg>
      <div class="text">
          <div>这是你今年新游里游玩时间跨度最大的游戏</div>
          <div>你们初见是在<span class="span1" :style="colorSty">{{data.firstPlayTtime}}</span></div>
          <div>最后一次视线交汇是在<span class="span1" :style="colorSty">{{data.lastPlayTtime}}</span></div>
          <div>若水三千，你最终还是回头看到了它~<img src="../../assets/image/steam/right_big.png"></div>
      </div>
      <footerPage class="footerPage"></footerPage>
      <footerBg class="footerBg" :footerBg="footerBg"></footerBg>
    </div>
</template>
  
  <script>
  import headerPage from '../../components/header.vue'
  import gameImg from '../../components/gameImg.vue'
  import footerPage from '../../components/footer.vue'
  import footerBg from '../../components/footerBg.vue'
  import headerBg from '../../components/headerBg.vue'
  export default {
        props:{
            data:{
                type:[Object]
            }
        },
      data(){
          return {
              title:'年度陪伴新游',
              iconSrc:require('../../assets/image/'+this.$route.query.type+'/'+this.$route.query.type+'_small.png'),
               headerSty:{
                padding:'7.2rem 0 0 1.95rem'
              },
               footerBg:{
                top:'26rem',
                height:'16rem',
                background: 'url('+require('../../assets/image/'+this.$route.query.type+'/longTimeGameBg.png')+')',
                backgroundSize: '77%',
                backgroundRepeat:'no-repeat',
                backgroundPosition: 'top right',
                // backgroundAttachment: 'fixed',

              },
            headerBg:{
                height:'12.45rem',
                background: 'url('+require('../../assets/image/steam/headerBg.png')+')',
                backgroundRepeat:'no-repeat',
                backgroundSize:'300%',
                backgroundPosition: '8% 15%',
                // backgroundAttachment: 'fixed',
            },
            game:{},
            colorSty:{},
            
          }
      },
       mounted(){
       
        if(this.$route.query.type=='steam'){
            this.colorSty={
                color:'#5EE6FF'
            }
        }else if(this.$route.query.type=='psn'){
            this.colorSty={
                color:'#5EA6FF'
            }
        }else if(this.$route.query.type=='xbox'){
             this.colorSty={
                color:'#5EFF97'
            }
        }else if(this.$route.query.type=='epic'){
            this.colorSty={
                color:'#FF5E5E'
            }
        }
        this.$set(this.game,'gameImg',this.data.gameCover)
        this.$set(this.game,'gameName',this.data.gameName)
      },
        
        methods:{
            getNumber(val){
                if(val){
                    return val.toFixed(0)
                }
                
            }
    
        },
      components:{
          headerPage,
          gameImg,
        footerPage,
        footerBg,
        headerBg
      }
  }
  </script>
  
  <style>
  
 #longTimeGame .text{
      padding: 0 1.95rem;
      font-size: 0.7rem;
      font-family: Source Han Sans CN;
      color:rgba(255, 255, 255, 0.8);
  }
  #longTimeGame .text div{
      margin-bottom: 1.35rem;
  }
 #longTimeGame  .text .span1{
      font-size: 1.4rem;
      font-family: Impact;
      color: #5EE6FF;
      margin-left: 0.3rem;
  }
 #longTimeGame .text .span2{
      font-size: 0.7rem;
      font-family: Source Han Sans CN;
      color: #5EE6FF;
      margin-left: 0.35rem;
  }
 #longTimeGame .text .span3{
      font-size: 0.7rem;
      font-family: Source Han Sans CN;
      color: #5EE6FF;
      margin-left: 0.7rem;

  }
  #longTimeGame .text>div:last-child{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    #longTimeGame .text img{
        width: 1.8rem;
        height: 1.5rem;
        
    }
  </style>